// Generated, reviewed identities shared by the Worker and both scene renderers.
import catalogue from './noaaCatalogue.json';

export const NOAA_CATALOGUE = catalogue;
export type NoaaCatalogueEntry = (typeof catalogue.entries)[number];
/** Identity lookup for metadata and model assignment. Never match only by display name. */
export function noaaEntry(id: string, noradId?: string | number | null): NoaaCatalogueEntry | undefined {
  return catalogue.entries.find(
    (e) => e.id === id && (noradId === undefined || String(e.noradId ?? '') === String(noradId ?? '')),
  );
}
export function noaaAssetId(id: string): string {
  return `mission:noaa:${id}`;
}
